module.exports = __webpack_public_path__ + "static/GraphiQL-alerts-results-c8a7ed28fc6af1ba953b69a95bdb41c7.png";